import api from './api';
import { AbonnementClientRequest, AbonnementClientResponse, AbonnementCreationRequest, AbonnementCreationResponse } from '../types';

export const abonnementService = {
  createForVehicule: (vehiculeId: number, data: AbonnementCreationRequest) =>
    api.post<AbonnementCreationResponse>(`/api/abonnements/vehicule/${vehiculeId}`, data).then((r) => r.data),
  createForClient: (clientId: number, data: AbonnementClientRequest) =>
    api.post<AbonnementClientResponse>(`/api/abonnements/client/${clientId}`, data).then((r) => r.data),
};
